// extracted by mini-css-extract-plugin
export var linkText = "_nr-0";